var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    width: this.canvasWidth,
    height: this.canvasHeight
  }),on:{"mousedown":function($event){return _vm.selectPage(_vm.pIndex)},"touchstart":function($event){return _vm.selectPage(_vm.pIndex)}}},[_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }